(function () {
  'use strict';

  /* ============================================================
     HERO DA HOME — indicativo de navegação + velocidade (03/Ago/2026)

     Pedido do time de mídia: o banner passava devagar e não tinha
     nenhum indicativo de que dava pra passar pro lado.

     O que faz:
       1) VELOCIDADE: baixa o autoplay para SPEED_MS. O setting nativo
          do tema (autoplay_speed) tem piso de 3s no schema, então 2,5s
          só é possível reconfigurando o player do Flickity em runtime.
       2) INDICATIVO: injeta setas laterais + indicador "combo" — as
          bolinhas mostram quantos banners existem e a bolinha ativa se
          estica virando uma barra que enche conforme o tempo corre.

     Por que não usar o show_navigation nativo:
       O nativo entrega setas + dots, mas não comunica o TEMPO (metade
       do pedido) e o markup dele vive dentro do bloco de conteúdo do
       slide, herdando cores/posição do texto de cada banner — nossas
       artes são full-bleed e sem texto de tema, então o nativo fica
       deslocado. Este asset injeta na raiz da section, sempre no mesmo
       lugar, independente do conteúdo do slide.

     Comportamentos não-óbvios:
       - O motor é FLICKITY (via <slideshow-element> em theme.js). NÃO
         reimplementamos o carrossel: usamos a API pública (select/next/
         previous/playPlayer/pausePlayer) e o evento 'change' pra manter
         a UI em sincronia com quem realmente manda no slide.
       - A section usa Motion.inView / initWhenVisible: o Flickity só
         nasce quando o hero entra na viewport. Por isso esperamos a
         instância aparecer em vez de assumir que existe no load.
       - A barra é CSS animation reiniciada a cada 'change'. Em pausa
         (hover/aba oculta) a animação é pausada junto, senão a barra
         mentiria sobre o tempo restante.
       - Respeita prefers-reduced-motion: sem "cutucada" na seta e sem
         barra correndo (o dot fica estático), mantendo a navegação.

     Escopo: só a section do slideshow da home (SECTION_SELECTOR).
     Rollback: remover a linha do theme.liquid.
     ============================================================ */

  try {

    // Guard de carga dupla do ASSET (include repetido). Não impede re-montagem
    // por shopify:section:load — essa é controlada pelo check de UI já existente
    // dentro de build(), pra o editor do tema seguir funcionando.
    if (window.__GD_HERO_NAV_LOADED) return;
    window.__GD_HERO_NAV_LOADED = true;

    /* ======================== CONFIG ======================== */

    var SPEED_MS = 2500;                 // velocidade aprovada no mockup
    var SECTION_SELECTOR = '[id^="shopify-section-"][id*="slideshow"]';
    var STYLE_ID = 'gd-hero-nav-css';
    var UI_CLASS = 'gd-hero-nav';

    var reduceMotion = window.matchMedia &&
                       window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ======================== CSS ======================== */

    function injectCSS() {
      if (document.getElementById(STYLE_ID)) return;
      var css =
        /* container do indicador */
        '.' + UI_CLASS + '{position:absolute;bottom:16px;left:50%;transform:translateX(-50%);' +
        'display:flex;align-items:center;gap:8px;z-index:6;pointer-events:auto;}' +

        '.' + UI_CLASS + '__dot{width:9px;height:9px;padding:0;border:0;border-radius:999px;' +
        'cursor:pointer;background:rgba(255,255,255,.5);box-shadow:0 1px 3px rgba(0,0,0,.25);' +
        'transition:width .45s cubic-bezier(.4,0,.2,1),background .3s;overflow:hidden;position:relative;}' +
        '.' + UI_CLASS + '__dot.is-active{width:38px;background:rgba(255,255,255,.45);}' +
        '.' + UI_CLASS + '__dot > i{position:absolute;inset:0;width:0;display:block;' +
        'background:#fff;border-radius:999px;}' +
        '.' + UI_CLASS + '__dot.is-active > i{animation:gd-hero-fill linear forwards;}' +
        '.' + UI_CLASS + '__dot.is-paused > i{animation-play-state:paused;}' +
        '@keyframes gd-hero-fill{from{width:0}to{width:100%}}' +

        /* setas */
        '.gd-hero-arrow{position:absolute;top:50%;transform:translateY(-50%);width:38px;height:38px;' +
        'border-radius:50%;background:rgba(255,255,255,.92);border:0;cursor:pointer;z-index:6;' +
        'display:none;align-items:center;justify-content:center;box-shadow:0 2px 10px rgba(0,0,0,.18);' +
        'transition:background .2s,transform .2s;padding:0;}' +
        '.gd-hero-arrow:hover{background:#fff;}' +
        '.gd-hero-arrow svg{width:17px;height:17px;stroke:#1E192A;fill:none;stroke-width:2.5;' +
        'stroke-linecap:round;stroke-linejoin:round;}' +
        '.gd-hero-arrow--prev{left:14px;}' +
        '.gd-hero-arrow--next{right:14px;}' +
        /* mobile navega por swipe (Flickity) — setas só do md pra cima,
           mesmo critério do markup nativo (hidden md:block) */
        '@media (min-width:768px){.gd-hero-arrow{display:flex;}}' +

        (reduceMotion ? '' :
          '@media (min-width:768px){.gd-hero-arrow--next{animation:gd-hero-nudge 2.4s ease-in-out infinite;}}' +
          '@keyframes gd-hero-nudge{0%,82%,100%{transform:translateY(-50%) translateX(0)}' +
          '88%{transform:translateY(-50%) translateX(5px)}94%{transform:translateY(-50%) translateX(0)}}') +

        /* o slideshow precisa ser âncora de posicionamento */
        '.gd-hero-host{position:relative;}';

      var st = document.createElement('style');
      st.id = STYLE_ID;
      st.textContent = css;
      document.head.appendChild(st);
    }

    /* ======================== HELPERS ======================== */

    var SVG_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
    var SVG_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';

    // Espera a instância do Flickity nascer (a section só inicializa quando
    // entra na viewport, via Motion.inView / initWhenVisible) — por isso NÃO
    // dá pra assumir que existe no load. Se estourar o timeout, chamamos o
    // callback mesmo assim com null: a UI é montada e os controles passam a
    // usar o fallback por evento (slider:next/previous), que o próprio
    // SlideshowElement escuta. Assim a navegação nunca fica invisível.
    function whenSlider(el, cb, timeoutMs) {
      var waited = 0, step = 100, max = timeoutMs || 12000;
      if (el.slider && typeof el.slider.select === 'function') { cb(el.slider); return; }
      var t = setInterval(function () {
        if (el.slider && typeof el.slider.select === 'function') {
          clearInterval(t);
          cb(el.slider);
          return;
        }
        waited += step;
        if (waited >= max) { clearInterval(t); cb(null); }
      }, step);
    }

    /* ======================== BUILD ======================== */

    function build(section) {
      var el = section.querySelector('slideshow-element');
      if (!el) return;

      // Contagem de slides: preferir el.items (getter do SlideshowElement,
      // cacheado ANTES do Flickity reorganizar o DOM). Só cai pro children
      // quando o custom element ainda não foi upgraded.
      var slides = (el.items && el.items.length)
        ? el.items
        : (el.children ? Array.prototype.slice.call(el.children) : []);
      if (slides.length < 2) return;          // 1 banner: nada a navegar

      // Host de posicionamento: o pai direto do slideshow-element já é
      // <div class="relative"> no tema. A classe gd-hero-host garante o
      // position:relative mesmo se esse wrapper mudar no futuro.
      var host = el.parentElement || section;
      host.classList.add('gd-hero-host');

      if (host.querySelector('.' + UI_CLASS)) return;   // idempotente

      whenSlider(el, function (slider) {
        // Fallback quando o Flickity ainda não nasceu: dispara os eventos que
        // o próprio SlideshowElement escuta (slider:next / slider:previous).
        // A navegação funciona igual; só o "select direto" vira next/prev.
        function goNext()  { slider ? slider.next()     : el.dispatchEvent(new CustomEvent('slider:next')); }
        function goPrev()  { slider ? slider.previous() : el.dispatchEvent(new CustomEvent('slider:previous')); }
        function goTo(idx) {
          if (slider) { slider.select(idx); return; }
          var cur = currentIndex();
          if (idx === cur) return;
          (idx > cur ? goNext : goPrev)();
        }
        function currentIndex() {
          if (slider && typeof slider.selectedIndex === 'number') return slider.selectedIndex;
          return parseInt(el.getAttribute('selected-index'), 10) || 0;
        }

        // ---- velocidade: reconfigura o player do Flickity ----
        try {
          if (slider) {
            slider.options.autoPlay = SPEED_MS;
            if (typeof slider.pausePlayer === 'function') slider.pausePlayer();
            if (typeof slider.playPlayer === 'function') slider.playPlayer();
          }
        } catch (e) { /* segue com a velocidade do tema */ }

        // ---- setas ----
        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'gd-hero-arrow gd-hero-arrow--prev';
        prev.setAttribute('aria-label', 'Banner anterior');
        prev.innerHTML = SVG_PREV;

        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'gd-hero-arrow gd-hero-arrow--next';
        next.setAttribute('aria-label', 'Próximo banner');
        next.innerHTML = SVG_NEXT;

        prev.addEventListener('click', goPrev);
        next.addEventListener('click', goNext);

        // ---- indicador combo ----
        var nav = document.createElement('div');
        nav.className = UI_CLASS;
        nav.setAttribute('role', 'tablist');
        nav.setAttribute('aria-label', 'Navegação dos banners');

        var dots = slides.map(function (_, idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = UI_CLASS + '__dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Banner ' + (idx + 1) + ' de ' + slides.length);
          b.innerHTML = '<i></i>';
          b.addEventListener('click', function () { goTo(idx); });
          nav.appendChild(b);
          return b;
        });

        host.appendChild(prev);
        host.appendChild(next);
        host.appendChild(nav);

        // ---- sincronia com o Flickity ----
        function paint() {
          var cur = currentIndex();
          dots.forEach(function (d, idx) {
            var bar = d.querySelector('i');
            var isActive = idx === cur;
            d.classList.toggle('is-active', isActive);
            d.setAttribute('aria-selected', isActive ? 'true' : 'false');
            // reinicia a animação só no ativo
            bar.style.animation = 'none';
            void bar.offsetWidth;                       // força reflow
            if (isActive && !reduceMotion) {
              bar.style.animation = 'gd-hero-fill ' + SPEED_MS + 'ms linear forwards';
            } else if (isActive) {
              bar.style.width = '100%';                 // reduced-motion: sem correr
            }
          });
        }

        if (slider) {
          slider.on('change', paint);
        } else {
          // sem instância: o SlideshowElement reflete o slide atual no
          // atributo selected-index — observamos ele pra manter a UI em dia.
          new MutationObserver(paint).observe(el, {
            attributes: true, attributeFilter: ['selected-index']
          });
        }

        // pausa/retoma a barra junto com o autoplay do Flickity, senão
        // a barra mentiria sobre o tempo restante
        function setPaused(p) {
          dots.forEach(function (d) { d.classList.toggle('is-paused', p); });
        }
        host.addEventListener('mouseenter', function () { setPaused(true); });
        host.addEventListener('mouseleave', function () { setPaused(false); });
        document.addEventListener('visibilitychange', function () {
          setPaused(document.hidden);
        });

        paint();
      });
    }

    /* ======================== BOOT ======================== */

    function boot() {
      injectCSS();
      var sections = document.querySelectorAll(SECTION_SELECTOR);
      Array.prototype.forEach.call(sections, build);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // Editor do tema: a section é substituída no DOM a cada alteração.
    // Limpa qualquer UI órfã antes de reconstruir, senão o editor acumula
    // setas/dots duplicados a cada save.
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.id || e.target.id.indexOf('slideshow') === -1) return;
      var stale = e.target.querySelectorAll('.' + UI_CLASS + ', .gd-hero-arrow');
      Array.prototype.forEach.call(stale, function (n) {
        if (n.parentNode) n.parentNode.removeChild(n);
      });
      injectCSS();
      build(e.target);
    });

  } catch (e) {
    console.warn('[HERO-NAV] fatal error:', e);
  }
})();
